import React from 'react';
import styled from 'styled-components';
import { BadgeDescription } from '../atoms/badgeDescription';
import { BadgeTitle } from '../atoms/badgeTitle';

interface SellerMainBadgeProps {
  image: string;
  title: string;
  description: string;
}

export const SellerMainBadge = ({ image: Icon, title, description }: SellerMainBadgeProps) => (
  <Wrapper>
    <Icon />
    <TextContainer>
      <BadgeTitle title={title} />
      <BadgeDescription description={description} />
    </TextContainer>
  </Wrapper>
);

const Wrapper = styled.div`
  margin: 0 16px;
  padding: 16px 0;
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    padding-bottom: 0;
  }
`;

const TextContainer = styled.div`
  margin-left: 8px;
`;
